export default "__VITE_ASSET__BkWT42ce__"